import { ShiftType } from '$constants'
import dayjs, { Dayjs } from 'dayjs'

export interface BreakDetail {
  id: string
  type: ShiftType
  breakStart: Dayjs
  breakEnd: Dayjs
  paid: boolean
  createdAt: Dayjs
  deletedAt: Dayjs | null
  errorMessage?: string
}

// Functions to apply transformations to BreakDetail object
export const transformBreakDetailOnGet = (
  breakDetail: BreakDetail
): BreakDetail => {
  return {
    ...breakDetail,
    breakStart: dayjs(breakDetail.breakStart),
    breakEnd: dayjs(breakDetail.breakEnd),
  }
}

export const transformBreakDetailOnSave = (
  breakDetail: BreakDetail
): object => {
  return {
    ...breakDetail,
    breakStart: breakDetail.breakStart.utc(),
    breakEnd: breakDetail.breakEnd.utc(),
  }
}
